import React, { useEffect, useState } from "react";
import Navbar from '../components/Navbar';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, CircularProgress, Button } from "@mui/material";
import { FailedPaylocityRequestsService } from "../services/FailedPaylocityRequestService";
import { userStore } from "../store/store";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';

const FailedPaylocityRequests: React.FC = () => {
  const [requests, setRequests] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");
  const [resolveDialogOpen, setResolveDialogOpen] = useState(false);
  const [resolveNote, setResolveNote] = useState("");
  const [resolvingId, setResolvingId] = useState<number | null>(null);
  const uStore: any = userStore();

  useEffect(() => {
    // Replace with your actual API endpoint
    FailedPaylocityRequestsService.GetFailedRequests()
      .then((data) => {
        setRequests(data.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Unknown error");
        setLoading(false);
      });
  }, []);

  const openResolveDialog = (id: number) => {
    setResolvingId(id);
    setResolveNote("");
    setResolveDialogOpen(true);
  };

  const closeResolveDialog = () => {
    setResolveDialogOpen(false);
    setResolvingId(null);
    setResolveNote("");
  };

  async function handleResolve(): Promise<void> {
    if (resolvingId == null) return;
    try {
      setLoading(true);
      setError("");
      await FailedPaylocityRequestsService.ResolveFailedRequest(resolvingId, resolveNote, uStore.getUser().id || 0);
      // Refresh the list after resolving
      const data = await FailedPaylocityRequestsService.GetFailedRequests();
      setRequests(data.data);
      closeResolveDialog();
    } catch (err: any) {
      setError(err.message || "Failed to resolve request");
    } finally {
      setLoading(false);
    }
  }

  const user = uStore.getUser();
  if (user.role !== "Administrator") {
    return (
      <>
        <Navbar title="TechHub" />
        <Paper sx={{ m: 4, p: 2 }}>
          <Typography variant="h6" color="error">
            You do not have permission to view this page.
          </Typography>
        </Paper>
      </>
    );
  }

  return (
    <>
      <Navbar title="TechHub" />
      <Paper sx={{ m: 4, p: 2 }}>
        <Typography variant="h5" gutterBottom>
          Failed Paylocity Requests
        </Typography>
        {loading ? (
        <CircularProgress />
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Error</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requests.length > 0 ? (
                requests.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.id}</TableCell>
                    <TableCell>{row.created_date ? (() => {
                      const date = new Date(row.created_date + 'Z');
                      const locale = navigator.language;
                      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
                      const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: tz, timeZoneName: 'short' };
                      return date.toLocaleString(locale, options);
                    })() : ""}</TableCell>
                    <TableCell>{row.error}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => openResolveDialog(row.id)}
                      >
                        Resolve
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No failed requests
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
        </Paper>
      <Dialog open={resolveDialogOpen} onClose={closeResolveDialog}>
        <DialogTitle>Resolve Failed Request</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Resolution Note"
            type="text"
            fullWidth
            multiline
            minRows={2}
            value={resolveNote}
            onChange={e => setResolveNote(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeResolveDialog}>Cancel</Button>
          <Button onClick={handleResolve} variant="contained" color="primary" disabled={loading || !resolveNote.trim()}>
            Resolve
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default FailedPaylocityRequests;
